import React from "react";
import { useTranslate } from 'react-redux-multilingual';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import swal from "sweetalert2";

// Style import
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const  ClearOutButton = (props) => {
    const t = useTranslate();

    return (
            <OverlayTrigger
                placement="bottom"
                overlay={
                    <Tooltip>
                        {t(props.title)}
                    </Tooltip>
                }
            >
                <span 
                    className="text-danger" 
                    style={{cursor:'pointer'}} 
                    onClick={() => {
                        swal
                        .fire({
                            title: t(props.messageConfirm)+" ?",
                            icon: "warning",
                            type: "question",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: t('btnYes'),
                            cancelButtonText: t('btnNo'),
                        })
                        .then((result) => {
                            if (result.value) {
                                props.customClickEvent(props.deleteFunctionArgument)
                            } else {
                                swal.fire(t('canceled'), "", "error");
                            }
                        });
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} />
                </span>
            </OverlayTrigger>  
    )
}

export default ClearOutButton;